import React from "react";
function Footer() {
  return (
    <footer className="container text-center py-2 fixed bottom-0 left-4 right-0 bg-white dark:bg-dark-mode">
      <p className="text-xs text-center text-dark-content dark:text-light-content w-full">
        Designed and Coded by <b>Swaraj Anand </b>
        with
        <span className="text-gradient font-medium"> Love 💖</span>
      </p>
    </footer>
  );
}
export default Footer;
